import type { IconDefinition } from '../index.tsx';

export const iconCamera: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconCamera',
  icon: [
    16,
    16,
    [],
    '',
    'M13 3H16V14H0V3H3L5 1H11L13 3ZM8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5Z',
  ],
};
